import React, { ReactElement } from 'react'

import { UserWithHourBalances } from '../../@paco/entities/HourBalances/HourBalances'

import SaldoItem from '../../components/SaldoItem/SaldoItem'
import SaldoItemGroup from '../../components/SaldoItemGroup/SaldoItemGroup'
import { translate } from '../../helpers/translations/translator'


export default function EmployeeSaldoGroup({
    absenceHours,
    specialLoaHours,
    tvtLoaHours,
    mutatedTvtHours,
    leaveOfAbsenceHours,
    vacancyLoaHours,
    workedHours,
    isEligibleForTimeForTime,
}: UserWithHourBalances): ReactElement {
    return (
        <div className="loket-hours-per-period__saldo-items">
            <SaldoItemGroup>
                <SaldoItem
                    isTitle
                    title={translate('pages.absences.loketBalancesPerPeriod.usedLeaveAbsenceHours')}
                    hours={leaveOfAbsenceHours}
                />
                <SaldoItem
                    title={translate('pages.absences.loketBalancesPerPeriod.vacancyLeaveOfAbsenceHours')}
                    hours={vacancyLoaHours}
                />
                <SaldoItem
                    title={translate('pages.absences.loketBalancesPerPeriod.specialLeaveOfAbsenceHours')}
                    hours={specialLoaHours}
                />
                <SaldoItem
                    title={translate('pages.absences.loketBalancesPerPeriod.tvtLeaveOfAbsenceHours')}
                    hours={tvtLoaHours}
                />
            </SaldoItemGroup>
            {isEligibleForTimeForTime && (
                <SaldoItem
                    isTitle
                    title={translate('pages.absences.loketBalancesPerPeriod.tvtMutationHours')}
                    hours={mutatedTvtHours}
                />
            )}
            <SaldoItem
                isTitle
                title={translate('pages.absences.loketBalancesPerPeriod.absenceHours')}
                hours={absenceHours}
            />
            <SaldoItem
                isTitle
                title={translate('pages.absences.loketBalancesPerPeriod.workedHours')}
                hours={workedHours}
            />
        </div>
    )
}
